
































import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  name: "BaseSimpleSlider",
  components: { VueSlider },
  data: function () {
    return {
      hover: false,
      /* dat: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3], */
      railStyle: {
        backgroundColor: "#8F8F8F",
        boxShadow: "none",
        height: "2px",
      },
      railColorSliderStyle: {
        background:
          "linear-gradient(90deg,rgb(255, 255, 255),rgb(255, 255, 255), rgb(30, 255, 0), rgb(0, 255, 13), rgb(0, 255, 60), rgb(0, 255, 145), rgb(0, 255, 191), rgb(0, 255, 234), rgb(0, 234, 255), rgb(0, 191, 255), rgb(0, 145, 255), rgb(0, 102, 255), rgb(0, 59, 255), rgb(0, 13, 255), rgb(30, 0, 255), rgb(72, 0, 255), rgb(115, 0, 255), rgb(162, 0, 255), rgb(204, 0, 255), rgb(246, 0, 255), rgb(255, 0, 217), rgb(255, 0, 174), rgb(255, 0, 132), rgb(255, 0, 89), rgb(255, 0, 43), red, rgb(255, 45, 0), rgb(255, 89, 0), rgb(255, 132, 0), rgb(255, 174, 0), rgb(255, 217, 0), rgb(246, 255, 0), rgb(204, 255, 0))",
        boxShadow: "none",
        height: "2px",
      },
      processStyle: {
        backgroundColor: "#fdcf30",
      },
      processColorSliderStyle: { backgroundColor: "transparent" },
      dotStyle: {
        height: "12px",
        width: "12px",
        border: "none",
        backgroundColor: "#fdcf30",
        boxShadow: "none",
      },
      dotStyleHover: {
        height: "12px",
        width: "12px",
        border: "none",
        backgroundColor: "#ffd648",
        boxShadow: "none",
      },
    };
  },
  props: {
    value: {
      type: Number,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100,
    },
    step: {
      type: Number,
      default: 1,
    },
    isFloat: {
      type: Boolean,
      default: false,
    },
    isColorSlider: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateSelf(value: string) {
      this.$emit("input", this.isFloat ? parseFloat(value) : parseInt(value));
    },
  },
};
